import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import Stack from '@mui/material/Stack'
import { useEffect } from 'react'
import { ActivityHistoryFilterForm } from './ActivityHistoryFilter/ActivityHistoryFilterForm'
import { useData } from './hooks/useData'
import { useHandlers } from './hooks/useHandlers'
import { SearchResults } from './SearchResults/SearchResults'
import { filtersToSearchInput } from '../../effects/filtersToSearchInput'
import { useActivitiesContext } from '../../context'
import { useRefreshActivityHistory } from '@user/features/Activity'

type Props = {
  entityId: number
  entityType: ENTITY_TYPES
  servicesCount: number
  agreementsCount: number
  paymentsCount: number
  appointments: any[]
  salesFunnelStageId: number
  assigneeId: string | null
}

export function ActivityHistoryContent(props: Props) {
  const {
    entityId,
    entityType,
    servicesCount,
    agreementsCount,
    paymentsCount,
    appointments,
    salesFunnelStageId,
    assigneeId,
  } = props
  const { filtersStatus } = useData()
  const { onCheckboxChange, setSearch } = useHandlers()
  const [{ filters }] = useActivitiesContext()
  const { refreshHistory } = useRefreshActivityHistory(entityId, entityType)

  useEffect(() => {
    refreshHistory()
  }, [
    refreshHistory,
    servicesCount,
    agreementsCount,
    paymentsCount,
    salesFunnelStageId,
    appointments,
    assigneeId,
  ])

  useEffect(() => {
    setSearch(filtersToSearchInput(entityId, entityType, filters))
  }, [entityId, entityType, filters, setSearch])

  return (
    <Stack direction="row">
      <ActivityHistoryFilterForm
        onChange={onCheckboxChange}
        requestStatus={filtersStatus}
        {...props}
      />
      <SearchResults {...props} />
    </Stack>
  )
}
